import { ref } from '@vue/composition-api'

const defaultState = () => ({
  config: ref({}),
  reports: ref({}),
  paramsUrl: ref({}),
})

export default defaultState
